import React, { FC, ReactNode } from 'react';

import * as S from './BrandPageBackground.styles';

export type BrandPageBackgroundProps = {
  background?: string;
  children?: ReactNode;
  image?: string;
  align?: 'right' | 'left';
};

export const BrandPageBackground: FC<BrandPageBackgroundProps> = ({
  background,
  children,
  image,
  align = 'right',
}) => {
  return (
    <S.Background $background={background}>
      {image ? <S.Image id="background-image" src={image} $align={align} loading="lazy" /> : null}
      {children}
    </S.Background>
  );
};
